<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    pageName: 'home',
    ignoreOnBoarding: true
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Seo
useSeoMeta({
    title: () => staticKeys.value?.header_navigation_home_web,
    /*
    ogImage: 'https://www.myce.de/images/app-download-invite-v2-desktop.png',
    twitterTitle: () => staticKeys.value?.header_navigation_home_web,
    twitterDescription: '[twitter:description]',
    twitterImage: 'https://www.myce.de/images/app-download-invite-v2-desktop.png',
    twitterCard: 'summary'
    */
})

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.WELCOME_PAGE,
})

// Define app download config
const commonAppContent = computed(() => {
    return {
        title: staticKeys.value?.account_gettheapp_fallback_headline,
        description: staticKeys.value?.account_gettheapp_fallback_copytext
    }
})

// Modal store
const modalStore = useModalStore()
const { toggleModal, addModalContent } = modalStore

// Show app teaser, depending on router query (appears if user clicks on universal or app link in newsletter etc. and gets redirected
const showAppTeaser = useRouteQuery('showModal')

if (showAppTeaser.value === 'appTeaser') {
    addModalContent(commonAppContent.value)
    toggleModal(true)
}
</script>

<template>
    <PageMainContainer :page-main-container-config="{ fullbleed: true }">
        <AppDownloadHeader />
        <HeroTeaser />
    </PageMainContainer>
</template>
